import { NotFound } from "@dgs/core";
import { FC } from "react";
import { Route, Routes } from "react-router";
import { AccessTokenList } from "./AccessTokenList";

export const AccessTokenPage: FC = () => {
	return (
		<Routes>
			<Route index element={<AccessTokenList />} />
			<Route path="*" element={<NotFound />} />
		</Routes>
	);
};
